/// <reference path="../objects/classes/User.ts"/>
/// <reference path="../objects/interfaces/IAccountService.ts"/>
/// <reference path="../factories/snackbar.factory.ts" />
/// <reference path="../objects/interfaces/IEncryptionService.ts"/>
/// <reference path="../services/encryption.service.ts"/>
/// <reference path="../objects/constants.ts" />

module App.Services {
    import User = Classes.User;

    export class AccountService implements App.Interfaces.IAccountService {
        static serviceId = 'accountService';

        static $inject = [
            '$q',
            HttpHelper.factoryId,
            SnackbarFactory.factoryId,
            EncryptionService.serviceId
        ];

        constructor(
            private $q: ng.IQService, 
            private httpHelperFactory: IHttpHelper,
            private snackbarFactory: Interfaces.ISnackbarFactory,
            private encryption: Interfaces.IEncryptionService
        ) {
            this.getConfig();
        }


        $get = () => {
            return this;
        }

        isAuthenticated: boolean;
        user: User;

        private getConfig = () => {
            this.httpHelperFactory.post<Oidc.UserManagerSettings>(
                Constants.websiteUrlCalls.getOpenIdConfig,
                { Pipeline: Variables.configuratorType },
                { 'setParam': window.location.search, 'AmegaPlannerFranchise': App.Variables.websiteId }
                ).then((result) => {
                    result.client_id = this.encryption.decrypt(result.clientId);
                    result.client_secret = this.encryption.decrypt(result.clientSecret);
                    this.userManager = new Oidc.UserManager(result);
                })
                .catch((error) => {
                    console.log("Could not get OpenId config: ", error)
                });
        }

        getUser = () => {
            var deferred = this.$q.defer<Classes.User>();
            if (this.isAuthenticated) {
                deferred.resolve(this.user);
            } else {
                var clientKey = sessionStorage.getItem("clientKey");
                var token = sessionStorage.getItem("token");
                if (clientKey && token) {

                    this.httpHelperFactory.post<User>(
                            Constants.websiteUrlCalls.getUser,
                            {"ClientKey": clientKey},
                            {"Authorization": "Bearer " + token}
                        )
                        .then((result) => {
                            if (result == null) {
                                //|| result.licensePlates == null 
                                //|| result.licensePlates.length === 0
                                this.snackbarFactory.show('Deze gebruiker kon niet worden ingelogd.', 4000);
                                deferred.reject();
                            } else {
                                this.isAuthenticated = true;
                                this.user = result;
                                deferred.resolve(result);
                            }
                            deferred.resolve(result);
                        })
                        .catch((err) => {
                            deferred.reject(err.message);
                            sessionStorage.clear();
                        });
                }
            }
            return deferred.promise;
        }

        private userManager: Oidc.UserManager;

        login = () => {
            var params = new URLSearchParams(window.location.search);
            var stateObject = Object.fromEntries(params);
            this.userManager.signinRedirect({state: stateObject});
        }

        logout = () => {
            this.user = null;
            this.isAuthenticated = false;

            sessionStorage.removeItem("clientKey");
            sessionStorage.removeItem("token");
            
            this.userManager.signoutRedirect();
        }

        createAccount = (firstName, lastName, licensePlate, email) => {
            this.httpHelperFactory.post(
                Constants.websiteUrlCalls.addUser,
                {
                    "voornaam": firstName,
                    "naam": lastName,
                    "kenteken": licensePlate,
                    "email": email
                },
                { 'AmegaPlannerFranchise': App.Variables.websiteId });
        }

    }

    app.service(AccountService.serviceId, AccountService);
}